(function () {
  function closeReviewPopup() {
    if (window.jQuery && jQuery.magnificPopupT4s) {
      jQuery.magnificPopupT4s.close();
    }
  }

  // The popup's fetched markup can be cached (data-storageid) and reshown,
  // so clear any leftover success/error message as soon as the shopper
  // starts a fresh submission.
  document.addEventListener('input', function (event) {
    var form = event.target.closest('[data-review-form]');
    if (!form) return;
    var wrapper = form.closest('.t4s-review-form-wrapper');
    var messageEl = wrapper ? wrapper.querySelector('[data-review-form-message]') : null;
    if (messageEl && !messageEl.hidden) {
      messageEl.hidden = true;
      messageEl.classList.remove('t4s-review-form__message--error', 't4s-review-form__message--success');
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-review-form]');
    if (!form) return;
    event.preventDefault();

    var wrapper = form.closest('.t4s-review-form-wrapper');
    var messageEl = wrapper ? wrapper.querySelector('[data-review-form-message]') : null;
    var submitBtn = form.querySelector('.t4s-review-form__submit');

    var formData = new FormData(form);
    formData.append('product_id', form.dataset.productId);

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitBtn.dataset.originalText || submitBtn.textContent;
      submitBtn.textContent = '...';
    }
    if (messageEl) {
      messageEl.hidden = true;
      messageEl.classList.remove('t4s-review-form__message--error', 't4s-review-form__message--success');
    }

    fetch('/apps/reviews/submit', {
      method: 'POST',
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!messageEl) return;
        messageEl.hidden = false;
        if (result.ok && result.data.success) {
          var autoApproved = !!result.data.auto_approved;
          messageEl.textContent = autoApproved ? messageEl.dataset.msgApproved : messageEl.dataset.msgPending;
          messageEl.classList.add('t4s-review-form__message--success');
          form.reset();
          if (autoApproved) {
            // Reload so the shopper immediately sees their own review and the updated rating.
            setTimeout(function () { window.location.reload(); }, 1800);
          } else {
            setTimeout(closeReviewPopup, 2200);
          }
        } else {
          // FastAPI's raised HTTPExceptions return {"detail": "..."}; our own
          // ReviewResponse error shape uses {"error": "..."} - handle both.
          var errorText = (result.data && (result.data.error || result.data.detail)) || messageEl.dataset.msgError;
          messageEl.textContent = errorText;
          messageEl.classList.add('t4s-review-form__message--error');
        }
      })
      .catch(function () {
        if (!messageEl) return;
        messageEl.hidden = false;
        messageEl.textContent = messageEl.dataset.msgError;
        messageEl.classList.add('t4s-review-form__message--error');
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.originalText;
        }
      });
  });
})();
